import React, { useMemo } from 'react';
import { Checkbox } from '@progress/kendo-react-inputs';
import { usePortalPages } from '../../../../Hooks/Display/usePages';
import { useAttributeFormBuilder, useFetchedValues } from '../../../../Hooks/Display/useComponentProperties';
import { useTranslation } from 'react-i18next';

const ColumnHyperlink = ({ column }) => {

    const { t } = useTranslation([
        "display/components/form"
    ]);

    const [{ steps }, dispatch] = useAttributeFormBuilder();
    const portalPages = usePortalPages();
    const [fetchedValues] = useFetchedValues();
    const { attributeTable: { referenceAttributePages, attributes } } = fetchedValues;
    const attribute = attributes.find((attr) => attr._id === column.attributeId);

    const targetPages = useMemo(() => (
        referenceAttributePages && referenceAttributePages.length > 0 ? portalPages.concat(referenceAttributePages) : portalPages
    ), [portalPages, referenceAttributePages]);

    const handleToggleHyperlinkColumn = (event) => {
        let targetPageId = ""
        if (event.target.value === true) {
            const targetPage = getTargetPageByEntityId(attribute.entityId);
            targetPageId = targetPage ? targetPage._id : "";
        }
        dispatch.toggleColumnHyperlink(column.attributeId, event.target.value, targetPageId)
    }

    const getTargetPageByEntityId = (entityId) => {
        const singleRecordPages = targetPages.filter(page => page.subPageType === "Single Record");
        const targetPage = singleRecordPages.find(page => page.entityId === entityId);
        return targetPage;
    }

    return (
        <Checkbox
            title={t("column.title.hyperlink", { ns: "display/components/form" })}
            className='me-2'
            value={column.hyperlink}
            onChange={handleToggleHyperlinkColumn}
        />
    );
}

export default ColumnHyperlink;